import { AttioValuationItemQueryResponse } from '../attio.types';
import { AttioValuationDetailResponse } from '../shared-types';
import { BaseAttioService } from './BaseAttioService';

export class AttioValuationDetailService extends BaseAttioService {
  constructor() {
    super('AttioValuationDetailService');
  }

  /**
   * Get a single valuation item with related data
   */
  async getValuationDetail(valuationRecordId: string): Promise<AttioValuationDetailResponse> {
    try {
      return await this.get<AttioValuationDetailResponse>(
        this.endpoints.retrieveValuationFullDetailByRecordId(valuationRecordId)
      );
    } catch (error) {
      this.handleError(error, 'getValuationDetail');
    }
  }

  async getValuationByRecordId(valuationRecordId: string): Promise<AttioValuationItemQueryResponse> {
    try {
      const response = await this.get<AttioValuationItemQueryResponse>(
        this.endpoints.retrieveValuationByRecordId(valuationRecordId)
      );
      return response;
    } catch (error) {
      this.handleError(error, 'getValuationByRecordId');
      throw error;
    }
  }
}
